// @flow
import React, { Fragment } from 'react';
import TextField from '@atlaskit/textfield';
import Button, { ButtonGroup } from '@atlaskit/button';
import { Checkbox } from '@atlaskit/checkbox';
import Form, {
  CheckboxField,
  Field,
  FormFooter,
  HelperMessage,
  ErrorMessage,
  ValidMessage,
} from '@atlaskit/form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'


import {
  INITIALIZE,
  INITIALIZE_SUCCESS,
  INITIALIZE_FAILURE
} from 'constants/ActionTypes';

import { withoutAuth } from 'HOC';
import { login } from "api/actions";

import Spacer from 'components/Spacer';

import commonStyle from 'commonStyle';

import './index.css';

const LoginComponent = (props) => {
  const { errorMessage } = props;

  return (
    <div className='login-container'>
      <img
        className='logo'
        src={require("assets/midrive.png")}
      />
  
      <Spacer />
  
      <Form
        onSubmit={data => props.login(data)}
      >
        {({ formProps, submitting }) => (
          <form {...formProps}>
            <Field name="email" label="Email" isRequired defaultValue="">
              {({ fieldProps, error }) => (
                <Fragment>
                  <TextField style={commonStyle.input} type="email" autoComplete="off" {...fieldProps} />
                  {!error && (
                    <HelperMessage>
                      You can use letters, numbers & periods.
                    </HelperMessage>
                  )}
                  {error && (
                    <ErrorMessage>
                      This user name is already in use, try another one.
                    </ErrorMessage>
                  )}
                </Fragment>
              )}
            </Field>
            <Field
              name="password"
              label="Password"
              defaultValue=""
              isRequired
              validate={value => (value.length < 4 ? 'TOO_SHORT' : undefined)}
            >
              {({ fieldProps, error, valid }) => (
                <Fragment>
                  <TextField style={commonStyle.input} type="password" {...fieldProps} />
                  {!error && !valid && (
                    <HelperMessage>
                      Use 4 or more characters with a mix of letters, numbers &
                      symbols.
                    </HelperMessage>
                  )}
                  {error && (
                    <ErrorMessage>
                      Password needs to be more than 8 characters.
                    </ErrorMessage>
                  )}
                  {valid && <ValidMessage>Awesome password!</ValidMessage>}
                </Fragment>
              )}
            </Field>
            {errorMessage && (
              <ErrorMessage>
                {errorMessage}
              </ErrorMessage>
            )}
            <CheckboxField name="remember" label="Remember me" defaultIsChecked>
              {({ fieldProps }) => (
                <Checkbox {...fieldProps} label="Always sign in on this device" />
              )}
            </CheckboxField>
            <FormFooter>
              <ButtonGroup>
                <Button type="submit" appearance="primary" isLoading={submitting}>
                  Login
                </Button>
              </ButtonGroup>
            </FormFooter>
          </form>
        )}
      </Form>
    </div>
  )
};

const mapStateToProps = (state) => ({
  email: state.email,
  errorMessage: state.errorMessage,
  password: state.password,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ login }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(
  withoutAuth(LoginComponent)
)
